module.exports = __webpack_public_path__ + "img/banner1.eedd60fe.png";